import styles from "./index.module.less";
import { getAllMusicFolders, getCollectMusic, getMusicList } from "@/services/music";
import React, { Fragment, useEffect, useState, useRef } from "react";
import fileIcon from "@/assets/create-space/file_img-min.png";
import { Checkbox, Image, Message, ModalProps, Spin } from "@arco-design/web-react";
import QuickStore from "@/stores/quickCutStore";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
import clearImg from "@/assets/create-space/script-clear.png";
import { observer } from "mobx-react";
import MusicCard from "../MusicCard/MusicCard";
import MusicPlayer from "@/pages/VideoClips/QuickCut/BgConfig/BgMusicConfig/BgMusicTabs/BgMusicContainer/MusicPlayer/MusicPlayer";
import { get } from "http";
import { getId } from "@/utils/tool";
import { toJS } from "mobx";
type Props = {
  selectAll: boolean;
  keyWord: string;
  isUserAction?: React.MutableRefObject<boolean>;
  emitIsUserAction: (value: boolean) => void;
};
const CustomNewMusic = observer((props: Props) => {
  const { selectAll, keyWord, isUserAction, emitIsUserAction } = props;
  const [fileList, setFileList] = useState([]);
  const [fileId, setFileId] = useState(0);
  const [fileName, setFileName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const { bgAudio } = useCoverAndBg();
  const { background } = QuickStore.quickcutData.settings;
  const [checkedIds, setCheckedIds] = useState<number[]>(background.musics?.map((item) => item.id) || []);
  const [currentId, setCurrentId] = useState<number>(null);
  const loadMoreRef = useRef(null);
  const [imgPage, setImgPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [currentMusic, setCurrentMusic] = useState<{
    src: string;
    title: string;
    isPlay: boolean;
    duration: number;
  }>(null);
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 30,
  });
  useEffect(() => {
    getAllMusicFolders({
      page: 1,
      page_size: 999,
    }).then((res) => {
      setFileList(res?.items || []);
    });
  }, []);

  useEffect(() => {
    if (!isUserAction.current) return;
    if (tableData?.length > 0) {
      if (selectAll) {
        // 全选逻辑
        const newSelectedMusics = [...background.musics];
        const newCheckedIds = [...checkedIds];
  
        tableData.forEach(item => {
          if (!newCheckedIds.includes(item.id)) {
            newSelectedMusics.push({
              ...item,
              duration: item.duration * 1000,
            });
            newCheckedIds.push(item.id);
          }
        });
  
        background.musics = newSelectedMusics;
        setCheckedIds(newCheckedIds);
      } else {
        const currentPageIds = tableData.map(item => item.id);
        const newMusics = background.musics.filter(
          music => !currentPageIds.includes(music.id)
        );
        background.musics = newMusics;
        setCheckedIds(prev => prev.filter(id => !currentPageIds.includes(id)));
      }
    }
    emitIsUserAction(false)
  }, [selectAll, tableData]);

  const getList = async (page: number, isAppend: boolean) => {
    setLoading(true);
    const res = await getMusicList({
      page: page,
      page_size: pagination.page_size,
      id: fileId,
      keyword: keyWord,
      order_by: "created_at",
      order_type: "desc",
    });
    setTableData((prev) => (isAppend ? [...prev, ...(res.items || [])] : res.items || []));
    setHasMore(res.items.length === 30);
    setLoading(false);
  };
  useEffect(() => {
    getList(pagination.page, false);
  }, [fileId, pagination, keyWord]);

  useEffect(() => {
    setCheckedIds((background.musics || []).map((item) => item.id));
  }, [background.musics]);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading && hasMore) {
          const nextPage = imgPage + 1;
          setImgPage(nextPage);
          getList(nextPage, true);
        }
      },
      { root: null, rootMargin: "0px", threshold: 0.1 }
    );
    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }
    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [loading, hasMore, imgPage]);

  const handleCheckMusic = (result: boolean, id: number) => {
    if (result) {
      // 添加音乐
      const item = (tableData as any[]).find((item) => Number(item.id) === Number(id));
      if (item) {
        background.musics = [...background.musics, { ...item, duration: item.duration * 1000 }];
        setCheckedIds([...checkedIds, id]);
      }
    } else {
      // 移除音乐
      const index = background.musics.findIndex((item) => Number(item.id) === Number(id));
      if (index !== -1) {
        const newMusics = [...background.musics];
        newMusics.splice(index, 1);
        background.musics = newMusics;
        setCheckedIds(checkedIds.filter((checkedId) => checkedId !== id));
      }
    }
  };

  const getIds = () => {    
    if (background.musics?.length > 0) {
      return background.musics.map((item) => item.id);
    }
    return [];
  }
  return (
    <div className={styles["cus-main"]} style={{ flex: 1 }}>
      {!fileId && (
        <div className={`${styles["custom-box"]} custom-style-custom-box`}>
          {fileList?.length > 0 &&
            fileList.map((item) => {
              return (
                <div
                  onClick={() => {
                    setFileId(item.id);
                    setFileName(item.name);
                  }}
                  className={styles["file-item"]}
                  key={item.id}
                >
                  <img className={styles["img"]} src={fileIcon} alt="" />
                  <div
                    className={styles["info"]}
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {item.name}
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {fileId && tableData?.length > 0 ? (
        <div className={styles["cus-bread"]}>
          <span
            style={{ color: "#333333", cursor: "pointer" }}
            onClick={() => {
              setFileId(0);
              setTableData([]);
              setPagination({
                page: 1,
                page_size: 30,
              })
              setImgPage(1)
              setHasMore(true)
              setFileName("");
            }}
          >
            自定义
          </span>{" "}
          / <span>{fileName}</span>
        </div>
      ) : (
        <></>
      )}
      {fileId ? (
        <div className={`${styles["music-card-wrapper"]} custom-style-card-wrapper`}>
          {tableData?.length > 0 &&
            tableData.map((item, index) => (
              <Fragment key={item.name + item.id}>
                <MusicCard
                  showCollect={false}
                  handleCheckMusic={(e) => {
                    handleCheckMusic(e, item.id);
                  }}
                  currentId={currentId}
                  handleCancelCollectBtnClick={() => {
                    // todo
                  }}
                  hanldeCollectBtnClick={() => {
                    // todo
                  }}
                  onClick={() => {
                    setCurrentMusic({
                      title: item.name,
                      src: item.play_info?.play_url,
                      duration: item.duration / 1000,
                      isPlay: true,
                    });
                    setCurrentId(item.id);
                  }}
                  handleCheckStateChange={(e) => {
                    handleCheckMusic(e, item.id);
                  }}
                  style={{
                    width: "calc(50% - 10px)",
                    marginRight: 9,
                    marginBottom: 9,
                    position: "sticky",
                  }}
                  checkState={getIds().includes(item.id)}
                  data={item}
                />
              </Fragment>
            ))}
          <div ref={loadMoreRef} style={{ height: 1 }} />
        </div>
      ) : (
        <></>
      )}
      {fileId && tableData?.length === 0 && !loading ? (
        <div className={styles["empty"]}>
          <img src={clearImg} alt="" />
          <p>暂无数据</p>
        </div>
      ) : (
        <></>
      )}
      {fileId && loading ? <Spin className={styles["empty"]}></Spin> : <></>}
      {currentMusic?.isPlay && (
        <MusicPlayer
          handleCloseBtnClick={() => {
            setCurrentMusic(null);
            setCurrentId(null);
          }}
          style={{ position: "absolute", bottom: 0, right: 0, left: 0, width: "calc(100% - 70px)" }}
          duration={currentMusic.duration}
          src={currentMusic.src}
          title={currentMusic.title}
        />
      )}
    </div>
  );
});
export default CustomNewMusic;
